module.exports = __webpack_public_path__ + "img/parking.63a1b97c.png";